var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-progress-spinner',{attrs:{"md-mode":"indeterminate","md-diameter":_vm.diameter || 60,"md-stroke":3}})}
var staticRenderFns = []

export { render, staticRenderFns }